import { useCurrentAgentId } from '@/features/chats/stores';
import { getChatStores } from '@/features/chats/lib/chat-store-bindings';
import { ChatWidgetToggle } from '../ChatWidgetToggle/ChatWidgetToggle';
import { ChatWidgetVersionsProps } from './ChatWidgetVersions.types';

export const ChatWidgetVersions = ({ agentId, messageId }: ChatWidgetVersionsProps) => {
  const currentAgentId = useCurrentAgentId();
  const useWidgetStore = getChatStores().widgetStore.useWidgetStore;
  const setActiveVersion = useWidgetStore((state) => state.setActiveVersion);
  const getVersionsForMessage = useWidgetStore((state) => state.getVersionsForMessage);

  // Try currentAgentId first (streaming), fallback to agentId (reload/handoff)
  const { versions, resolvedAgentId } = getVersionsForMessage(currentAgentId, messageId, agentId);

  const activeVersionId = useWidgetStore((state) => {
    const history = state.agentHistories[resolvedAgentId];
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return history ? history.activeVersionId : undefined;
  });

  if (versions.length === 0) {
    return null;
  }

  const handleToggleClick = (versionId: string) => {
    setActiveVersion(resolvedAgentId, versionId);
  };

  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {versions.map((version) => (
        <ChatWidgetToggle
          key={version.id}
          agentId={resolvedAgentId}
          version={version}
          forceActive={version.id === activeVersionId}
          onClick={() => handleToggleClick(version.id)}
        />
      ))}
    </div>
  );
};
